import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling-light";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OcpsPoliciesFetch" */ "./lazyIndex"), { name: "OcpsPoliciesFetch" });

export const lazyInitializeOcpsPoliciesFromOwsPrime: LazyAction<typeof lazyIndex.initializeOcpsPoliciesFromOwsPrime, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeOcpsPoliciesFromOwsPrime);
